import { Box, Button, Center, IconButton, Menu, MenuButton, MenuItem, MenuList, useColorMode } from "@chakra-ui/react";
import { find } from "lodash";
import React from "react";
import { useTranslation } from "react-i18next";
import { HiMoon, HiSun } from "react-icons/hi";
import { useUIStore } from "stores/uiStore";

const ThemeModeBtn = (props) => {
    const { small = true } = props;
    const {t, i18n} = useTranslation('app');
	const { colorMode, toggleColorMode } = useColorMode();
    const [colorTheme,setColorTheme]= useUIStore((state) => [
        state.colorTheme,
        state.setColorTheme,
    ]);
	const themeList = [
		{
			label: t("spaceGray"),
			value: "spaceGray",
			colorHex: "#3e4d66",
		},
		{
			label: t("blue"),
			value: "blue",
			colorHex: "#3c51b9",
		},
		{
			label: t("golden"),
			value: "golden",
			colorHex: "#83644b",
		},
	];
    const matched = find(themeList, (o) => o.value === colorTheme);
	return (
		<Menu>
			<MenuButton
				size={"sm"}
				as={Button}
				aria-label="Options"
				boxShadow={"none"}
				variant={"ghost"}
				px={small ? 1 : 4}
			>
				<Center
					alignItems={"center"}
					display={"flex"}
					justifyContent={"center"}
				>
					<Box
						h={4}
						w={4}
						borderRadius={"md"}
						bgColor={matched?.colorHex}
					/>
				</Center>
			</MenuButton>
			<MenuList>
				{themeList.map((item) => (
					<MenuItem
						fontSize={"sm"}
						fontWeight={"500"}
						onClick={() => setColorTheme(item.value)}
						key={item.value}
						icon={
							<Center
								alignItems={"center"}
								display={"flex"}
								justifyContent={"center"}
							>
								<Box
									h={4}
									w={4}
									borderRadius={"md"}
									bgColor={item?.colorHex}
								/>
							</Center>
						}
						// icon={<CountryIcon country={item.county} size={24} />}
					>
						{item.label}
					</MenuItem>
				))}
			</MenuList>
		</Menu>
	);
};

export default ThemeModeBtn;
